import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
  Search,
  Funnel,
  Edit2,
  Plus,
  MoreHorizontal,
  ChevronsUpDown,
  ChevronLeft,
  ChevronRight,
  X,
  Copy,
  CircleCheck
} from 'lucide-react';
import { useHistory, useLocation } from "react-router-dom";
import { Info } from 'lucide-react';
import Tooltip from '../addentities/Tooltip';
import apiHelper from '../../apiHelper';
import Pagination from '../../components/Pagination';
import SortableHeader from '../../components/SortableHeader';
import FilterDrawer from '../../components/FilterDrawer';

const PAGE_SIZE = 10;

export default function Department() {
  const history = useHistory();
  const location = useLocation();
  const filterButtonRef = useRef(null);
  const filterPopupRef = useRef(null);
  const [successMessage, setSuccessMessage] = useState('');
  const breadcrumbs = ["Organisations", "Departments"];

  const [searchTerm, setSearchTerm] = useState('');
  const [searchStatus, setSearchStatus] = useState([]);
  const [searchParentDepartment, setSearchParentDepartment] = useState([]);
  const [searchSupervisor, setSearchSupervisor] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedIds, setSelectedIds] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [suppressHighlight, setSuppressHighlight] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerTab, setDrawerTab] = useState('entity-info');
  const [selectedRow, setSelectedRow] = useState(null);
  const [filterPopupOpen, setFilterPopupOpen] = useState(false);
  const [parentSearchTerm, setParentSearchTerm] = useState('');
  const [supervisorSearchTerm, setSupervisorSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [tempValues, setTempValues] = useState({
  status: [],
  parentDepartment: [],
  supervisor: [],
  parentDepartmentSearch: "",
  supervisorSearch: "",
});
const [filters, setFilters] = useState({
  status: [],
  parentDepartment: [],
  supervisor: [],
});

  const filtered = useMemo(() => {
    console.log('Filtering with:', { searchTerm, searchStatus, searchParentDepartment, searchSupervisor });
    const term = searchTerm.toLowerCase();
    return departments.filter(d => {
      console.log('Department Object:', d);

      const matchesSearch =
        !searchTerm ||
        d.department_name?.toLowerCase().includes(term) ||
        d.uuid?.toLowerCase().includes(term) ||
        d.notes?.toLowerCase().includes(term);

      const matchesStatus = searchStatus.length === 0 || searchStatus.includes(d.status?.toString());

      const departmentId = d.department_id?.toString() || '';
      const matchesParentDepartment = searchParentDepartment.length === 0 ||
        searchParentDepartment.includes(departmentId);

      const matchesSupervisor = searchSupervisor.length === 0 ||
        searchSupervisor.some(sup => (d.supervisor?.toString() || '').includes(sup));

      console.log('Matches:', {
        department: d.department_name,
        matchesSearch,
        matchesStatus,
        departmentId,
        matchesParentDepartment,
        matchesSupervisor
      });
      return matchesSearch && matchesStatus && matchesParentDepartment && matchesSupervisor;
    });
  }, [searchTerm, departments, searchStatus, searchParentDepartment, searchSupervisor]);

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const pageData = filtered.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  const handleToggleStatus = async (row) => {
    const activate = row.status_text !== 'Active';
    const action = activate ? 'activate' : 'deactivate';
    const updateData = { status: action };
    const response = await apiHelper(`departments/update-status/${row.department_id}/`, 'POST', updateData);
    if (response && response.ok) {
      setDepartments(departments.map(e =>
        e.department_id === row.department_id
          ? { ...e, status_text: activate ? 'Active' : 'Inactive' }
          : e
      ));
      setDropdownOpenId(null);
    }
  };

  const toggleSelect = id => {
    setSelectedIds(ids => {
      const newIds = ids.includes(id)
        ? ids.filter(x => x !== id)
        : [...ids, id];
      setSuppressHighlight(false);
      return newIds;
    });
  };

  const toggleAll = () => {
    setSelectedIds(prev => {
      const next =
        prev.length === pageData.length
          ? []
          : pageData.map(d => d.department_id);
      setSuppressHighlight(false);
      return next;
    });
  };

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      try {
        const response = await apiHelper('departments/list/');
        if (response && response.ok) {
          const result = await response.json();
          console.log('Fetched Departments:', result);
          setDepartments(result);
        }
      } catch (error) {
        console.error('Failed to fetch departments:', error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchData();
  }, []);

  const onRowClick = (row) => {
    setSelectedRow(row);
    setDrawerTab('entity-info');
    setDrawerOpen(true);
  };

  const removeSelectedId = (id) => {
    setSelectedIds(ids => {
      const next = ids.filter(x => x !== id);
      setSuppressHighlight(false);
      return next;
    });
  };

  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const dropdownRef = useRef(null);
  const buttonRefs = useRef({});
  const drawerRef = useRef(null);
  const [copied, setCopied] = useState(false);
  

  const currentRow = departments.find(e => e.department_id === dropdownOpenId);

  useEffect(() => {
    function handleClickOutsideDrawer(event) {
      if (
        drawerOpen &&
        drawerRef.current &&
        !drawerRef.current.contains(event.target)
      ) {
        setDrawerOpen(false);
        setSelectedRow(null);
        setSelectedIds(ids =>
          selectedRow ? ids.filter(id => id !== selectedRow.department_id) : ids
        );
      }
    }
    document.addEventListener('mousedown', handleClickOutsideDrawer);
    return () =>
      document.removeEventListener('mousedown', handleClickOutsideDrawer);
  }, [drawerOpen, selectedRow]);

  useEffect(() => {
    function handleClickOutsideFilter(event) {
      if (
        filterPopupOpen &&
        filterPopupRef.current &&
        !filterPopupRef.current.contains(event.target) &&
        !filterButtonRef.current.contains(event.target)
      ) {
        setFilterPopupOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutsideFilter);
    return () => document.removeEventListener('mousedown', handleClickOutsideFilter);
  }, [filterPopupOpen]);

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !buttonRefs.current[dropdownOpenId]?.contains(event.target)
      ) {
        setDropdownOpenId(null);
      }
    }

    if (dropdownOpenId !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpenId]);

  const toggleDropdown = (id) => {
    if (dropdownOpenId === id) {
      setDropdownOpenId(null);
    } else {
      const btn = buttonRefs.current[id];
      if (btn) {
        const rect = btn.getBoundingClientRect();
        const dropdownWidth = 150;
        const dropdownHeight = 100;

        let left = rect.left + window.scrollX - dropdownWidth + rect.width;
        if (left < window.scrollX + 8) {
          left = window.scrollX + 8;
        }

        let top = rect.bottom + window.scrollY;
        if (top + dropdownHeight > window.scrollY + window.innerHeight) {
          top = rect.top + window.scrollY - dropdownHeight;
        }

        setDropdownPosition({ top, left });
      }
      setDropdownOpenId(id);
    }
  };

  const editDepartment = () => {
    if (selectedIds.length === 1) {
      history.push(`/department/edit-department/${selectedIds[0]}`);
    }
  };

  const filterCount = [...searchStatus, ...searchParentDepartment, ...searchSupervisor].filter(Boolean).length;

  const handleCheckboxChange = (setter, value) => (e) => {
    const isChecked = e.target.checked;
    setter(prev =>
      isChecked
        ? [...prev, value]
        : prev.filter(v => v !== value)
    );
    setCurrentPage(1);
  };

  const [filterPosition, setFilterPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (filterPopupOpen && filterButtonRef.current) {
      const rect = filterButtonRef.current.getBoundingClientRect();
      setFilterPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX
      });
    }
  }, [filterPopupOpen]);

   const handleCopy = async (textToCopy) => {
        if (!textToCopy) {
            console.error('No text to copy');
            alert('Failed to copy: No text available.');
            return;
        }

        // Use Clipboard API if available and secure
        if (window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            try {
                await navigator.clipboard.writeText(textToCopy);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
            } catch (err) {
                console.error('Clipboard API failed:', err);
                fallbackCopyTextToClipboard(textToCopy);
            }
        } else {
            console.warn('Clipboard API not available or not in secure context, using fallback');
            fallbackCopyTextToClipboard(textToCopy);
        }
    };

    const fallbackCopyTextToClipboard = (text) => {
        try {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);

            if (successful) {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } else {
                console.error('Fallback copy failed');
                alert('Failed to copy text. Please copy manually.');
            }
        } catch (err) {
            console.error('Fallback copy error:', err);
            alert('Failed to copy text. Please copy manually.');
        }
    };

 useEffect(() => {
        // debug log to check what's coming in
        console.log('location.state on mount:', location.state);

        if (location && location.state && location.state.success) {
            setSuccessMessage(location.state.success);

            // clear that location.state so it doesn't reappear on refresh/back
            // for react-router v5: history.replace(pathname, state)
            history.replace(location.pathname, {});

            // auto-hide the success message after 3-4s
            const t = setTimeout(() => setSuccessMessage(''), 4000);
            return () => clearTimeout(t);
        }
    }, [location, history]);


    useEffect(() => {
        if (successMessage) {
            const t = setTimeout(() => setSuccessMessage(""), 4000);
            return () => clearTimeout(t);
        }
    }, [successMessage]);

     const FilterActiveIcon = () => (
        <svg style={{ margin: 0 }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.6325 6.44444C20.7252 6.24267 20.7746 6.02858 20.8107 5.74756C21.0354 4.00089 21.1478 3.12756 21.6356 2.56378C20.1234 2 19.2177 2 17.4063 2H4.59369C2.78227 2 1.87655 2 1.36439 2.56378C0.852232 3.12756 0.964572 4.00089 1.18925 5.74756C1.25487 6.25766 1.36399 6.54725 1.69704 6.94296C2.77293 8.22128 4.74334 10.4951 7.50829 12.5623C7.76095 12.7512 7.92676 13.0599 7.95475 13.4016C8.26623 17.2071 8.55159 19.8068 8.70309 21.0865C8.78256 21.7577 9.52673 22.274 10.14 21.8404C11.1702 21.1118 13.0947 20.2952 13.349 18.938C13.4692 18.2964 13.6451 17.1765 13.8437 15.3333" stroke="#0D6EFD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <g clipPath="url(#clip0_4516_4830)">
                <path d="M22.8125 11C22.8125 14.2102 20.2102 16.8125 17 16.8125C13.7898 16.8125 11.1875 14.2102 11.1875 11C11.1875 7.78987 13.7898 5.18753 17 5.18753C20.2102 5.18753 22.8125 7.78987 22.8125 11ZM16.3277 14.0777L20.6402 9.7652C20.7866 9.61877 20.7866 9.38132 20.6402 9.23488L20.1099 8.70456C19.9634 9.5581 19.726 9.5581 19.5795 8.70456L16.0625 12.2215L14.4205 10.5795C14.2741 10.4331 14.0366 10.4331 13.8901 10.5795L13.3598 11.1099C13.2134 11.2563 13.2134 11.4937 13.3598 11.6402L15.7973 14.0777C15.9438 14.2241 16.1812 14.2241 16.3277 14.0777Z" fill="#0D6EFD" />
            </g>
            <defs>
                <clipPath id="clip0_4516_4830">
                    <rect width="12" height="12" fill="white" transform="translate(11 5)" />
                </clipPath>
            </defs>
        </svg>
    );

    const FilterInactiveIcon = () => (
        <svg style={{ margin: 0 }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M21.6323 6.44444C21.7251 6.24267 21.7744 6.02858 21.8106 5.74756C22.0353 4.00089 22.1476 3.12756 21.6354 2.56378C21.1233 2 20.2176 2 18.4062 2H5.59366C3.78225 2 2.87655 2 2.36439 2.56378C1.85223 3.12756 1.96457 4.00089 2.18925 5.74756C2.25487 6.25766 2.36399 6.54725 2.69703 6.94296C3.77291 8.22128 5.74331 10.4951 8.50823 12.5623C8.76089 12.7512 8.9267 13.0599 8.95469 13.4016C9.26616 17.2071 9.55152 19.8068 9.70302 21.0865C9.78249 21.7577 10.5267 22.274 11.1399 21.8404C12.1701 21.1118 14.0946 20.2952 14.3489 18.938C14.4691 18.2964 14.645 17.1765 14.8436 15.3333" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.1113 7.5556V15.3334M22.0001 11.4445L14.2224 11.4445" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
const sections = [
  {
    key: "status",
    label: "Status",
    type: "checkbox",
   options: ["Active", "Inactive"],
  },
  {
  key: "parentDepartment",
  label: "Parent Entity",
  type: "list",
  data: departments,
  renderItem: (item) => ({
    id: item.department_id?.toString(),
    title: item.department_name,
  }),
},
  {
  key: "supervisor",
  label: "Supervisor",
  type: "list",
  data: [
    ...new Map(
      departments.map(d => [
        d.supervisor || "NA",
        { supervisor: d.supervisor || "NA" }
      ])
    ).values(),
  ],
  renderItem: (item) => ({
    id: item.supervisor,
    title: item.supervisor,
  }),
}
];

  return (
    <div className="company-body">
      <div className="breadcrumb">
        {breadcrumbs.map((crumb, index) => (
          <span key={index} className="breadcrumb-item">
            {crumb}
            {index !== breadcrumbs.length - 1}
          </span>
        ))}
      </div>

       {successMessage && (
                <div
                    className="d-flex align-items-center justify-content-between"
                    role="alert"
                    style={{
                        boxShadow: "0px 4px 10px 0px #0000001F",
                        padding: "15px 10px",
                        borderRadius: "12px",
                        border: "1px solid #30B473",
                        backgroundColor: "#E6F7EF",
                        color: "#0D6438",
                        fontSize: "12px",
                        position: "fixed",
                        top: "10px",
                        width: "calc(100% - 20px)",
                        maxWidth: "640px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 2000,
                    }}
                >
                    <div className="d-flex align-items-center">
                        <CircleCheck className="me-2" />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                            }}>
                            <strong>{successMessage}</strong>
                        </div>
                    </div>
     <X
                        size={16}
                        style={{ cursor: "pointer" }}
                        onClick={() => setSuccessMessage("")}
                    />
                </div>
            )}

      <div className="info-section">
        <div className="info-card">
          <div className="info-header">
            <h4 className="info-title">Departments</h4>
          </div>

          <div className="entities-tab">
            <div className="toolbar">
              <div className="toolbar-left">
                <div className="search-box">
                  <Search size={20} />
                  <input
                    type="text"
                    placeholder="Search…"
                    value={searchTerm}
                    onChange={e => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
                {/* <button
                  ref={filterButtonRef}
                  className="icon-btn new-look"
                  onClick={() => setFilterPopupOpen(!filterPopupOpen)}
                >
                  <Funnel size={18} /> Filter
                  {filterCount > 0 && (
                    <span className="filter-counts"
                      style={{
                        background: '#000',
                        color: '#ffffff',
                        borderRadius: '50%',
                        width: '16px',
                        height: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        marginLeft: '5px'
                      }}>
                      {filterCount}
                    </span>
                  )}
                </button> */}
                <button
                  ref={filterButtonRef}
                  // className={`icon-btn p-2 filter-btn ${filtersApplied ? 'applied' : ''}`}
                  className="icon-btn p-2 filter-btn "
                  onClick={() => setFilterPopupOpen(!filterPopupOpen)}   // ← Block clicks
                  // disabled={isTableEmpty}                 // ← NEW

                  style={{
                    // border: filtersApplied ? '1px solid #2C7BE5' : '1px solid #6C757D',
                    border: '1px solid #6C757D',
                    borderWidth: '1px',
                    // color: filtersApplied ? '#2C7BE5' : '#6C757D',
                    color: '#6C757D',
                    // background: isTableEmpty
                    //   ? '#E9ECEF'                     // ← background when empty
                    //   : filtersApplied
                    //     ? '#CFE2FF'
                    //     : '#FFFFFF',
                    background: '#FFFFFF',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // opacity: isTableEmpty ? 0.6 : 1,
                    // pointerEvents: isTableEmpty ? 'none' : 'auto',
                    opacity: 1,
                    pointerEvents: 'auto',
                  }}
                >
                  {/* {filtersApplied && !isTableEmpty ? <FilterActiveIcon /> : <FilterInactiveIcon />} */}
                  <FilterInactiveIcon />

                </button>
                 <FilterDrawer
                isOpen={filterPopupOpen}
                onClose={() => setFilterPopupOpen(false)}
                sections={sections}
                tempValues={tempValues}
                setTempValues={setTempValues}
                onApply={() => {
                  setFilters({
                    status: tempValues.status || [],
                    parentDepartment: tempValues.parentDepartment || [],
                    supervisor: tempValues.supervisor || [],
                  });

                  setFilterPopupOpen(false);
                }}
                onClear={() => {
                  const empty = {
                    status: [],
                    parentDepartment: [],
                    supervisor: [],
                    parentDepartmentSearch: "",
                    supervisorSearch: "",
                  };

                  setTempValues(empty);
                  setFilters(empty);
                }}
              />
              </div>
              <div className="toolbar-right">
                <button className="icon-btn">
                  <Edit2 size={18} onClick={editDepartment} />
                </button>
                <button
                  className="icon-btn"
                  onClick={() => history.push("/department/add-department")}
                >
                  <Plus size={18} />
                </button>
              </div>
            </div>


            <div className="table-wrapper">
              <table className="entities-table">
                <thead>
                  <tr>
                    <th>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={
                            selectedIds.length === pageData.length && pageData.length > 0
                          }
                          onChange={toggleAll}
                        />
                      </div>
                    </th>
                    <SortableHeader label="Department Name"> </SortableHeader>
                    <SortableHeader label="Status"> </SortableHeader>
                    <SortableHeader label="ID"> </SortableHeader>
                    <SortableHeader label="Parent Department"> </SortableHeader>
                    <SortableHeader label="Supervisor"> </SortableHeader>
                    <th style={{ textAlign: 'center' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {pageData.length > 0 ? (
                    pageData.map((row, idx) => {
                      const isRowSelected =
                        selectedIds.includes(row.department_id) &&
                        !suppressHighlight;

                      return (
                        <tr
                          key={row.department_id}
                          className={[
                            idx % 2 ? 'striped' : '',
                            isRowSelected ? 'row-selected' : ''
                          ].join(' ')}
                          onClick={() => onRowClick(row)}
                        >
                          <td>
                            <div className="form-check" onClick={e => e.stopPropagation()}>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={selectedIds.includes(row.department_id)}
                                onChange={e => {
                                  toggleSelect(row.department_id);
                                  if (e.target.checked) {
                                    setSelectedRow(row);
                                  } else if (selectedRow?.department_id === row.department_id) {
                                    setSelectedRow(null);
                                  }
                                }}
                              />
                            </div>
                          </td>
                          <td>{row.department_name}</td>
                          <td>
                            <span className={`status ${row.status_text.toLowerCase()}`}>
                              {row.status_text}
                            </span>
                          </td>
                          <td>{row.department_id}</td>
                          <td>{row.parent_name || 'NA'}</td>
                          <td>{row.supervisor_name || 'NA'}</td>
                          <td style={{ textAlign: "center", position: "relative" }}>
                            <button
                              ref={el => (buttonRefs.current[row.department_id] = el)}
                              className="icon-btn"
                              onClick={e => {
                                e.stopPropagation();
                                toggleDropdown(row.department_id);
                              }}
                            >
                              <MoreHorizontal size={20} />
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={7} style={{ textAlign: 'center', padding: '20px' }}>
                        No departments match the selected filters.
                      </td>
                    </tr>
                  )}

                  {pageData.length < PAGE_SIZE && pageData.length > 0 && (
                    [...Array(PAGE_SIZE - pageData.length)].map((_, idx) => (
                      <tr
                        key={`empty-${idx}`}
                        className="empty-row"
                        onClick={() => { }}
                      >
                        <td colSpan={7}> </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              {dropdownOpenId !== null && (
                <div
                  ref={dropdownRef}
                  className="backdrop-cls"
                  style={{
                    position: "absolute",
                    top: dropdownPosition.top,
                    left: dropdownPosition.left,
                    background: "white",
                    boxShadow: "0px 1px 4px 0px #0000001A",
                    zIndex: 1000,
                    minWidth: 152,
                    borderRadius: 8,
                    padding: 12,
                  }}
                  onClick={e => e.stopPropagation()}
                >
                  <div className="btn-align-forall">
                    <div className="common-for-all">
                      <button
                        onClick={() => {
                          onRowClick(currentRow);
                          setDropdownOpenId(null); // 👈 Close dropdown
                        }}
                      >
                        View Details
                      </button>
                    </div>

                    <div className="common-for-all">
                      <button
                        onClick={() => {
                          history.push(`/department/edit-department/${currentRow.department_id}`);
                          setDropdownOpenId(null); // 👈 Close dropdown
                        }}
                      >
                        Edit
                      </button>
                    </div>

                    <div className="common-for-all">
                      <button
                        onClick={() => {
                          handleToggleStatus(currentRow);
                          setDropdownOpenId(null); // 👈 Close dropdown
                        }}
                        className="deactivate-cls"
                      >
                        {currentRow.status_text === 'Active' ? 'Deactivate' : 'Activate'}
                      </button>
                    </div>
                  </div>

                </div>
              )}
            </div>

            {filtered.length > 0 && (
              <div className="pagination">
                <div className="pagination-info">
                  {` ${(currentPage - 1) * PAGE_SIZE + 1} - ${Math.min(
                    currentPage * PAGE_SIZE,
                    filtered.length
                  )} of ${filtered.length}`}
                </div>

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              </div>
            )}

          </div>
        </div>
      </div>

      {drawerOpen && selectedRow && (
        <>
          <div className="drawer-overlay" />
          <div className="entity-drawer" ref={drawerRef}>
            <div className="drawer-header">
              <h3>Department Info</h3>
              <button
                className="close-btn"
                onClick={() => {
                  setDrawerOpen(false);
                  setSelectedIds(ids => ids.filter(id => id !== selectedRow.department_id));
                  setSelectedRow(null);
                }}
              >
                <X size={24} />
              </button>
            </div>
            <div className="main-drawer-inner">
              <div className="drawer-title">
                <h2 className='pb-2'>Departments</h2>
              </div>
              <div className="drawer-tabs">
                <button
                  className={drawerTab === 'entity-info' ? 'active' : ''}
                  onClick={() => setDrawerTab('entity-info')}
                >
                  Department Info
                </button>
                <button
                  className={drawerTab === 'additional-info' ? 'active' : ''}
                  onClick={() => setDrawerTab('additional-info')}
                >
                  Additional Info
                </button>
              </div>
              <div className="drawer-content">
                {drawerTab === 'entity-info' ? (
                  <div className="tab-panel entity-info-panel">
                    <div className="field-block">
                      <div className="field-label">Department Name</div>
                      <div className="field-value">{selectedRow.department_name}</div>
                    </div>

                    <div className="field-block">
                      <div className="field-label">Status</div>
                      <div className="field-value">
                        <span
                          className={`status ${selectedRow.status_text.toLowerCase()}`}
                        >
                          {selectedRow.status_text}
                        </span>
                      </div>
                    </div>

                    <div className="field-block">
                      <div className="field-label">Open ID</div>
                      <div className="field-value d-flex align-items-center gap-2">
                        <span
                          style={{ color: "#2C7BE5", cursor: "pointer", textDecoration: "underline" }}
                          onClick={() => handleCopy(selectedRow.uuid)}
                        >
                          {selectedRow.uuid}
                        </span>
                        <Copy
                          size={13}
                          onClick={() => handleCopy(selectedRow.uuid)}
                          style={{ cursor: "pointer", color: "#2C7BE5" }}
                        />
                        {copied && <span style={{ fontSize: '12px', color: "#2C7BE5" }}>Copied!</span>}
                      </div>
                    </div>

                    <div className="field-block">
                      <div className="field-label">Parent Department</div>
                      <div className="field-value">{selectedRow.parent_name || 'NA'}</div>
                    </div>

                    <div className="field-block">
                      <div className="field-label">Supervisor</div>
                      <div className="field-value">{selectedRow.supervisor_name || 'NA'}</div>
                    </div>
                  </div>
                ) : (
                  <div className="tab-panel additional-info-panel">
                    <p className='note-type-added'>Note</p>
                    <label className='no-description-cls when-no-description-cls-adding notes-preserve'>{selectedRow.notes || 'NA'}</label>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}